export default __webpack_public_path__ + "static/media/empty-state-aircraft-not-found.8e8368c4.svg";